import { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Box, IconButton, Stack } from '@mui/material';
import moment from 'moment'
import useFetch from '../../../api/api'

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditTransactionDialog from './EditTransactionDialog';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { formatCurrency } from '../../../common/Helper';
import config from '../../../common/Config';

const TabTransactionList = (props) => {

	const { type, setDisplayErrorAlert, setDisplaySuccessAlert, setMessage} = props

	const [isDeleteConfirmOpen, setIsDeleteConfirmOpen]	= useState(false)
	const [deleteTransactionId, setDeleteTransactionId] = useState()

	const [isEditDialogOpen, setIsEditDialogOpen] 		= useState(false)
	const [currentTransaction, setCurrentTransaction] 	= useState()

	const [transactions, setTransactions] 				= useState([]);

	const privateFetch = useFetch();

	useEffect(() => {
		getTransactions()
	},[type])

	useEffect(() => {
		getTransactions()
	},[])	

	const getTransactions = () => {
		const options = {
			method : 'GET',
			headers : {
				'content-type' : 'application/json; charset=utf-8'
			}
		}

		privateFetch(config.apiUrl +"/api/transactions/"+ type.toUpperCase(), options)
		.then((data) => data.json())
		.then((data) => {
			setTransactions(data)
		})
	}	

	const handleRemoveTransactionConfirm = (pId) => {
		setDeleteTransactionId(pId)
		setIsDeleteConfirmOpen(true)
	}

	const handleRemoveTransaction = () => {
		const options = {
			method : "DELETE",
			headers : {
				"Content-Type" : "application/json"	
			}
		}

		privateFetch(config.apiUrl +"/api/transactions/"+ deleteTransactionId, options)
		.then(data => data.json())
		.then(data => {
			if (data.status === 500) {
				setDisplayErrorAlert(true)
				setMessage('Erro ao remover transação: '+ data.message)
			}
			else {
				getTransactions()		
			}
		})				
	}

	const handleOpenEditTransactionDialog = (pCurrentTransaction) => {
		setCurrentTransaction({
			id				: pCurrentTransaction.id,
			date			: pCurrentTransaction.date,
			stockTicker		: pCurrentTransaction.stockTicker,
			operation		: pCurrentTransaction.operation,
			quantity		: pCurrentTransaction.quantity,
			total			: pCurrentTransaction.total,
			cost			: pCurrentTransaction.cost
		})

		setIsEditDialogOpen(true)
	}

	const handleCloseEditTransactionDialog = () => {
		setIsEditDialogOpen(false)
		getTransactions()
	}

	const columns = [
		{ 
			field: 'date', 
			headerName: 'Data',
			renderCell: (cellValues) => {
				return (moment(cellValues.row.date).format("DD/MM/YYYY"))
			},
			disableColumnMenu : true
		},
		{ field: 'stockTicker', headerName: 'Ticker', disableColumnMenu : true},
		{ field: 'operation', headerName: 'Operação', disableColumnMenu : true},
		{ 
			field: 'quantity', 
			headerName: 'Qtd', 
			renderCell: (cellValues) => {
				return parseFloat(cellValues.row.quantity).toFixed(0)
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),			
			disableColumnMenu : true
		},
		{ 
			field: 'total', 
			headerName: 'Valor',
			renderCell: (cellValues) => {
				return (formatCurrency(parseFloat(cellValues.row.total), 'SMALL', type.toUpperCase() === 'STOCK' ? 'USD' : 'BRL'))
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true
		},
		{ 
			field: 'cost', 
			headerName: 'Custo',
			renderCell: (cellValues) => {
				return (formatCurrency(parseFloat(cellValues.row.cost), 'SMALL', type.toUpperCase() === 'STOCK' ? 'USD' : 'BRL'))
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true
		},			
		{ 
			field: 'totalPaid', 
			headerName: 'Total',
			valueGetter: (cellvalues, row) => (parseFloat(row.total) + parseFloat(row.cost)),
			renderCell: (cellValues) => {
				return (formatCurrency(parseFloat(cellValues.row.total) + parseFloat(cellValues.row.cost), 'SMALL', type.toUpperCase() === 'STOCK' ? 'USD' : 'BRL'))
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true
		},
		{ 
			field: 'actions',
			headerName : 'Ações',
			renderCell: (cellValues) => {
				return (
					<Stack direction={'row'}>{}
						<IconButton onClick={() => handleOpenEditTransactionDialog(cellValues.row)}><EditIcon sx={{fontSize: '1rem'}}/></IconButton>
						<IconButton onClick={() => handleRemoveTransactionConfirm(cellValues.row.id)}><DeleteIcon sx={{fontSize: '1rem'}}/></IconButton>
					</Stack>
				)
			},
			sortable: false,
			disableColumnMenu : true
		}
	]

	return(	
		<Box padding={1}>

			<EditTransactionDialog 
				open={isEditDialogOpen}
				closeHandler={handleCloseEditTransactionDialog}
				transaction={currentTransaction}
				setDisplaySuccessAlert={setDisplaySuccessAlert}
				setMessage={setMessage}
			/>

			<ConfirmDialog 
				title="Aviso"
				children="Tem certeza que deseja exluir o registro?"
				open={isDeleteConfirmOpen}
				setOpen={setIsDeleteConfirmOpen}
				onConfirm={handleRemoveTransaction}
			/>

			<DataGrid
				rows={transactions}
				getRowId={(row) => row.id} 
				columns={columns}
				pageSize={12}
				rowHeight={30}
				autoHeight={true}
				sx={{
					fontSize:12,
					width: '100%',
					'& .super-app-theme--cell': {
						backgroundColor: 'rgba(224, 183, 60, 0.55)',
						color: '#1a3e72',
						fontWeight: '600',
					},
					'& .super-app.negative': {
						color: '#008000', 
						fontWeight: '600',
					},
					'& .super-app.positive': {
						color: '#FF0000',
						fontWeight: '600',
					},
				}}
			/>

		</Box>			
	)
}

export default TabTransactionList